/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React, { useEffect } from "react";
import { Card, Grid } from "@material-ui/core";
import { ScheduledReportSettings } from "./ScheduledReportSettings";
import { ScheduledReportsProvider, useScheduledReports } from "../context/scheduledReports";
import { ShowSnackbar } from "../../../components/Common";

/**
 * This page allows the user to edit report configure.
 */
const PageContent = ({ setTabModified }) => {
	const [notification, setNotification] = React.useState({ message: "", severity: "success" });

	const { scheduledReports, loading, error, message, getScheduledReportsList } = useScheduledReports();

	useEffect(() => {
		const fetchData = async () => {
			await getScheduledReportsList();
		};
		fetchData();
	}, [getScheduledReportsList]);

	const handleSnackBarClose = () => {
		setNotification((cur) => ({ ...cur, message: "" }));
	};

	useEffect(() => {
		if (loading) {
			setNotification({ message: "", severity: "success" });
		} else if (error) {
			setNotification({ message: error, severity: "error" });
		} else {
			setNotification({ message, severity: "success" });
		}
	}, [loading, error, message]);

	return (
		<Card style={{ width: "100%" }}>
			<div style={{ minWidth: 800, minHeight: 200 }}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<ScheduledReportSettings setScheduleReportModified={setTabModified} scheduledReports={scheduledReports} />
					</Grid>
				</Grid>
			</div>
			<ShowSnackbar message={notification.message} severity={notification.severity} onClose={handleSnackBarClose} />
		</Card>
	);
};

const ScheduledReportsConfigSection = (props) => (
	<ScheduledReportsProvider>
		<PageContent {...props} />
	</ScheduledReportsProvider>
);

export default ScheduledReportsConfigSection;
